import { ThemeProvider } from "@mui/material";
import React from "react";
import UpdatesOverview from "../../Components/Updates/UpdatesOverview/UpdatesOverview.component";
import theme2 from "../../theme2";

function Updates(props) {
  return (
    <ThemeProvider theme={theme2}>
      <div>
        <UpdatesOverview
          project={props.match.params.projectId}
          userRoleForProject={props.userRoleForProject}
        />
      </div>
    </ThemeProvider>
  );
}

export default Updates;
